import { render } from "./Awards.vue?vue&type=template&id=aba3bd40&scoped=true&ts=true"
import script from "./Awards.vue?vue&type=script&lang=ts"
export * from "./Awards.vue?vue&type=script&lang=ts"

import "./Awards.vue?vue&type=style&index=0&id=aba3bd40&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aba3bd40"]])

export default __exports__